import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { ResourceFavourite } from "@modules/starred-resource/starred-resource-types.ts";

const starResource = (resourceUuid, resourceType, resourceStatus) => {
  const params = new URLSearchParams();
  params.append("resourceUuid", resourceUuid);
  params.append("resourceType", resourceType);
  params.append("resourceStatus", resourceStatus);
  return httpClient.post(`/apis/resource/favourite/add?${params}`);
};

const unstarResource = (starredResourceId) => {
  const params = new URLSearchParams();
  params.append("resourceFavouriteId", starredResourceId);
  return httpClient.post(`/apis/resource/favourite/remove?${params}`);
};

const unstarResourceMultiple = (uuids) => {
  const params = new URLSearchParams();
  params.append("resourceFavouriteIds", uuids);
  return httpClient.post(`/apis/resource/favourite/remove-all`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const fetchStarredResourcesByType = async (
  requestData,
): Promise<ApiResponse<ResourceFavourite[]>> => {
  return await httpClient.get(`/apis/resource/favourite/list/type`, {
    params: requestData,
  });
};

const fetchStarredResources = () => {
  return httpClient.get(`/apis/resource/favourite/list`);
};

const isStarred = (resourceUuid, resourceType, resourceStatus) => {
  return httpClient.get(`/apis/resource/favourite/is-favourite`, {
    params: {
      resourceUuid: resourceUuid,
      resourceType: resourceType,
      resourceStatus: resourceStatus,
    },
  });
};

export default {
  starResource,
  unstarResource,
  unstarResourceMultiple,
  fetchStarredResourcesByType,
  fetchStarredResources,
  isStarred,
};
